export const LogHistoryDrawerTestIds = {
  DRAWER: 'log-history-drawer.container',
  CLOSE_BUTTON: 'log-history-drawer.close-button',
  EXPAND_ALL_BUTTON: 'log-history-drawer.expand-all-button',
  COLLAPSE_ALL_BUTTON: 'log-history-drawer.collapse-all-button',
};
